<div class="min-h-screen bg-[#F3F4F6] dark:bg-slate-900 text-sm p-4 md:p-8 text-slate-600 dark:text-slate-300">
  <div class="animate-fade-in flex flex-col md:flex-row md:items-end justify-between mb-8 gap-4">
    <div>
      <h1 class="text-3xl font-extrabold text-slate-800 dark:text-slate-100 tracking-tight">Penalty Rate</h1>
      <p class="text-slate-500 dark:text-slate-400 mt-2 font-medium">
        จัดการอัตราค่าปรับ (parking_penalty_rate)
      </p>
    </div>
    <div class="flex flex-col sm:flex-row items-stretch sm:items-center gap-3 w-full sm:w-auto">
      <div *ngIf="lastFetchedTime"
        class="flex flex-col items-end justify-center text-right shrink-0 w-[112px] h-[46px]">
        <span class="text-[11px] text-slate-400 dark:text-slate-500 font-medium leading-none mb-1 whitespace-nowrap">ดึงข้อมูลล่าสุด</span>
        <span class="text-[13px] font-bold text-slate-600 dark:text-slate-400 leading-none tabular-nums">{{ lastFetchedTime | date:'HH:mm:ss' }}</span>
      </div>
      <button type="button" (click)="onRefresh()"
        class="p-3 bg-white dark:bg-slate-800 text-slate-500 dark:text-slate-400 rounded-xl shadow-sm border border-slate-200 dark:border-slate-700 hover:text-amber-500 dark:hover:text-amber-400 hover:shadow-md transition-all active:scale-95 flex items-center justify-center h-[46px]"
        title="รีเฟรชข้อมูล">
        <span class="material-icons">refresh</span>
      </button>
      <button *ngIf="canCreate" type="button" (click)="openCreate()"
        class="px-6 py-3 bg-amber-400 hover:bg-amber-500 text-white font-bold rounded-xl shadow-lg shadow-amber-200/50 dark:shadow-none flex items-center justify-center gap-2 h-[46px] transition-all">
        <span class="material-icons text-[18px]">add_circle</span>
        เพิ่ม Penalty Rate
      </button>
    </div>
  </div>

  <div class="animate-fade-in bg-white dark:bg-slate-800 rounded-3xl shadow-[0_4px_20px_rgb(0,0,0,0.03)] border border-slate-100 dark:border-slate-700 overflow-hidden relative"
    style="animation-delay: 0.1s;">
    <div class="p-6 border-b border-slate-100 dark:border-slate-700 flex flex-col lg:flex-row lg:items-center justify-between gap-4">
      <h3 class="text-lg font-bold text-slate-800 dark:text-slate-100 flex items-center gap-2">
        <span class="material-icons text-amber-500">gavel</span>
        รายการ Penalty Rate
      </h3>
      <div class="relative w-full sm:w-80">
        <span class="absolute left-3 top-1/2 -translate-y-1/2 material-icons text-slate-400 text-[20px] pointer-events-none">search</span>
        <input type="text" [ngModel]="searchText()" (ngModelChange)="searchText.set($event); onSearchChange()"
          placeholder="ค้นหา penalty_id / ชื่อ..."
          class="w-full pl-10 pr-4 bg-slate-50 dark:bg-slate-900 border border-slate-200 dark:border-slate-700 text-sm rounded-xl font-medium outline-none focus:ring-2 focus:ring-amber-200 dark:focus:ring-amber-500/30 h-[46px] text-slate-700 dark:text-slate-200 placeholder:text-slate-400">
      </div>
    </div>

    <div class="overflow-x-auto h-[520px] relative custom-scrollbar" [class.opacity-50]="isLoading()">
      <table class="w-full text-left border-collapse">
        <thead class="sticky top-0 z-20 bg-white/95 dark:bg-slate-800/95 backdrop-blur-sm shadow-sm">
          <tr class="text-xs font-bold text-slate-400 dark:text-slate-500 uppercase tracking-wider">
            <th class="p-5">ID</th>
            <th class="p-5">Penalty ID</th>
            <th class="p-5">ชื่อ</th>
            <th class="p-5">Over Time</th>
            <th class="p-5 text-right">Fine Price</th>
            <th class="p-5 text-center w-[110px]">จัดการ</th>
          </tr>
        </thead>
        <tbody class="divide-y divide-slate-50 dark:divide-slate-700">
          <tr *ngFor="let item of items(); trackBy: trackById"
            class="animate-table-row group hover:bg-amber-50/40 dark:hover:bg-slate-700/50 transition-colors duration-200">
            <td class="p-5 font-mono text-sm text-slate-400 dark:text-slate-500">{{ item.id }}</td>
            <td class="p-5 font-mono text-xs text-slate-600 dark:text-slate-300">{{ item.penaltyId || '—' }}</td>
            <td class="p-5 font-semibold text-slate-700 dark:text-slate-200">{{ item.name || '—' }}</td>
            <td class="p-5 text-sm text-slate-600 dark:text-slate-300">{{ item.overTime || '—' }}</td>
            <td class="p-5 text-right font-bold text-slate-700 dark:text-slate-200">
              {{ item.finePrice != null ? (item.finePrice | number:'1.2-2') : '—' }}
            </td>
            <td class="p-5 text-center">
              <button *ngIf="canUpdate" type="button" (click)="openEdit(item)"
                class="w-8 h-8 rounded-lg flex items-center justify-center border border-slate-100 dark:border-slate-700 hover:border-amber-400 text-slate-400 hover:text-amber-500 transition-all"
                title="แก้ไข">
                <span class="material-icons text-base">edit</span>
              </button>
            </td>
          </tr>
          <tr *ngIf="!isLoading() && items().length === 0">
            <td colspan="6" class="py-20 text-center">
              <div class="flex flex-col items-center justify-center text-slate-400">
                <span class="material-icons text-4xl mb-2">search_off</span>
                <p class="font-bold text-slate-700 dark:text-slate-200">ไม่พบข้อมูล</p>
                <span class="text-sm mt-1">ลองค้นหาใหม่หรือกดเพิ่ม Penalty Rate</span>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="px-6 py-4 border-t border-slate-100 dark:border-slate-700 flex flex-col md:flex-row items-center justify-between gap-4">
      <div class="text-sm text-slate-500 dark:text-slate-400 font-medium">
        แสดง {{ startItemIndex | number }} - {{ endItemIndex | number }} จาก {{ totalItems() | number }} รายการ
      </div>
      <div class="flex items-center gap-2">
        <button type="button" (click)="setPage(currentPage() - 1)" [disabled]="currentPage() === 1"
          class="w-9 h-9 flex items-center justify-center rounded-lg border border-slate-200 dark:border-slate-700 hover:text-amber-500 disabled:opacity-30 transition-all">
          <span class="material-icons text-sm">chevron_left</span>
        </button>
        <button *ngFor="let page of pagesArray" type="button" (click)="setPage(page)"
          class="w-9 h-9 flex items-center justify-center rounded-lg text-sm font-bold transition-all"
          [ngClass]="page === currentPage()
            ? 'bg-amber-400 dark:bg-amber-500 text-white shadow-lg shadow-amber-200 dark:shadow-none'
            : 'text-slate-600 dark:text-slate-300 hover:bg-amber-50 dark:hover:bg-slate-700'">
          {{ page }}
        </button>
        <button type="button" (click)="setPage(currentPage() + 1)"
          [disabled]="currentPage() === totalPages() || totalPages() === 0"
          class="w-9 h-9 flex items-center justify-center rounded-lg border border-slate-200 dark:border-slate-700 hover:text-amber-500 disabled:opacity-30 transition-all">
          <span class="material-icons text-sm">chevron_right</span>
        </button>
      </div>
    </div>
  </div>
</div>

<app-modal-parking-penalty-rate *ngIf="isModalOpen()" [itemId]="selectedId()"
  (close)="closeModal()" (saveSuccess)="closeModal(); loadTable()"></app-modal-parking-penalty-rate>

<app-pss-loading *ngIf="isLoading()"></app-pss-loading>
